// Mock data pour le site Ecopra Suisse - Distributeur officiel

export const siteInfo = {
  name: "Ecopra Suisse",
  tagline: "Économie de carburant de 15 à 35% - Distributeur officiel pour la Suisse",
  description: "Kit Universel Révolution'Air - Solution écologique pour tous moteurs",
  country: "Suisse 🇨🇭",
  currency: "CHF",
  owner: "Steve Rosset",
  phone: "+41 78 638 02 03",
  phoneDisplay: "078 638 02 03",
  email: "contact@ecopra.ch",
  address: {
    mainCity: "Sion",
    region: "Valais"
  },
  banking: {
    iban: "CH23 8080 8002 9180 7086 6",
    bank: "Banque Raiffeisen",
    beneficiary: "Steve Rosset"
  },
  creator: {
    name: "SAS ECOPRA",
    role: "Créateur et inventeur du système Ecopra",
    company: "Ecopra SAS - France",
    since: "Depuis 2007",
    origin: "Made in Auvergne"
  }
};

export const heroSlides = [
  {
    id: 1,
    title: "Économisez jusqu'à 35% de carburant",
    description: "Kit Universel Révolution'Air Ecopra - Un système unique, écologique, compatible avec tous les moteurs pour une économie de carburant de 15 à 30%",
    image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=1200&h=514&fit=crop",
    badge: "Edison Awards 2023 Nominee",
    link: "/presentation"
  },
  {
    id: 2,
    title: "Réduisez vos émissions polluantes",
    description: "Diminution de 80% de l'opacité des gaz d'échappement • Baisse des NOX de 40 à 60% • Réduction de la nuisance sonore de 4 à 8 décibels",
    image: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=1200&h=514&fit=crop",
    badge: "Made in France",
    link: "/technologie"
  },
  {
    id: 3,
    title: "Compatible tous véhicules",
    description: "Motos, voitures, camions, tracteurs agricoles, chaudières... Le kit Ecopra s'adapte à tous les moteurs à combustion interne",
    image: "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=1200&h=514&fit=crop",
    badge: "Installation en Suisse",
    link: "/boutique"
  }
];

export const products = [
  {
    id: 1,
    code: "BVA1",
    name: "Kit BVA1 - Moto / Scooter / Jet-ski",
    category: "Deux roues & loisirs motorisés",
    priceWithoutInstall: 319,
    priceWithInstall: 389,
    description: "Également adapté aux motoneiges, tracteurs tondeuses et bateaux à petits moteurs",
    image: "https://images.unsplash.com/photo-1558981852-426c6c22a060?w=400&h=300&fit=crop",
    features: [
      "Moto, scooter, jet-ski",
      "Motoneige",
      "Tracteur tondeuse",
      "Bateaux (petits moteurs)"
    ]
  },
  {
    id: 2,
    code: "BVA2",
    name: "Kit BVA2 - Voiture de moins de 2000 cm³",
    category: "Véhicules légers",
    priceWithoutInstall: 449,
    priceWithInstall: 549,
    description: "Kit pour voitures essence ou diesel de moins de 2000 cm³",
    image: "https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=400&h=300&fit=crop",
    features: [
      "Voitures < 2000 cm³",
      "Essence et diesel",
      "Installation en 50 minutes",
      "Sans modification moteur"
    ]
  },
  {
    id: 3,
    code: "BVA3",
    name: "Kit BVA3 - Voiture > 2000 cm³ / Camping-car / 4x4 / Utilitaire",
    category: "Véhicules puissants",
    priceWithoutInstall: 549,
    priceWithInstall: 649,
    description: "Kit pour voitures de plus de 2000 cm³, camping-cars, 4x4 et utilitaires",
    image: "/4x4-bva3.png",
    features: [
      "Voitures > 2000 cm³",
      "Camping-cars",
      "4x4",
      "Utilitaires"
    ]
  },
  {
    id: 4,
    code: "BVA4",
    name: "Kit BVA4 - Camion / Engin de chantier / Groupe électrogène / Maritime",
    category: "Engins lourds & maritime",
    priceWithoutInstall: 699,
    priceWithInstall: 849,
    description: "Kit pour camions, engins de chantier, groupes électrogènes et applications maritimes",
    image: "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?w=400&h=300&fit=crop",
    features: [
      "Camions",
      "Engins de chantier",
      "Groupes électrogènes",
      "Maritime"
    ]
  },
  {
    id: 5,
    code: "BVA5",
    name: "Kit BVA5 - Chauffage mazout / Poêle bois / Pellet / Fioul",
    category: "Chauffage & énergie domestique",
    priceWithoutInstall: 899,
    priceWithInstall: 1099,
    description: "Kit pour chaudières au mazout, poêles à bois, poêles à pellets et chauffages au fioul",
    image: "/chaudiere-mazout.png",
    features: [
      "Chaudière mazout",
      "Poêle à bois",
      "Poêle à pellet",
      "Chauffage fioul"
    ]
  },
  {
    id: 6,
    code: "BVA6",
    name: "Kit BVA6 - Machines lourdes / Industriel",
    category: "Usage industriel",
    priceWithoutInstall: 1099,
    priceWithInstall: 1299,
    description: "Solution pour machines lourdes et usage industriel",
    image: "https://images.unsplash.com/photo-1647427060118-4911c9821b82?w=400&h=300&fit=crop",
    features: [
      "Machines lourdes",
      "Moteurs industriels",
      "Grosses machines",
      "ROI rapide"
    ]
  }
];

// Frais de déplacement (selon distance)
export const travelFees = [
  { range: "0 – 20 km", label: "Inclus", value: 0 },
  { range: "20 – 50 km", label: "+40 CHF", value: 40 },
  { range: "50 – 100 km", label: "+80 CHF", value: 80 },
  { range: "+100 km", label: "Sur devis", value: null }
];

export const benefits = [
  {
    id: 1,
    title: "Économie de 15 à 35%",
    description: "Réduction significative de votre consommation de carburant. À chaque litre économisé, c'est 5 personnes sauvegardées de la pollution.",
    icon: "TrendingDown",
    color: "cyan"
  },
  {
    id: 2,
    title: "Edison Awards 2023 Nominee",
    description: "Reconnaissance internationale pour l'innovation et l'excellence technologique du système Ecopra.",
    icon: "Award",
    color: "yellow"
  },
  {
    id: 3,
    title: "Réduction des Émissions",
    description: "Diminution de 80% de l'opacité des gaz d'échappement et baisse des NOX de 40 à 60%. Réduction CO2 de 15 à 30%.",
    icon: "Leaf",
    color: "green"
  },
  {
    id: 4,
    title: "Compatible Tous Moteurs",
    description: "Système mécanique universel, sans électricité ni électronique. Compatible avec tous les carburants et moteurs.",
    icon: "Zap",
    color: "cyan"
  },
  {
    id: 5,
    title: "Made in France",
    description: "Conception et fabrication française garantissant une qualité supérieure et une fiabilité à toute épreuve.",
    icon: "Flag",
    color: "blue"
  },
  {
    id: 6,
    title: "Installation Professionnelle",
    description: "Service d'installation en Suisse par des professionnels certifiés. Garantie et support inclus.",
    icon: "Wrench",
    color: "cyan"
  }
];

export const technicalFeatures = [
  {
    title: "Diminution des températures",
    subtitle: "Eau, Huile et Gaz d'échappement",
    icon: "Thermometer"
  },
  {
    title: "Diminution de 80%",
    subtitle: "de l'opacité des gaz d'échappement",
    icon: "Wind"
  },
  {
    title: "Baisse des NOX",
    subtitle: "de 40 à 60% et des émissions de CO² de 15 à 30%",
    icon: "Leaf"
  },
  {
    title: "Réduction nuisance sonore",
    subtitle: "de 4 à 8 décibels",
    icon: "Volume2"
  },
  {
    title: "Plus grande souplesse",
    subtitle: "de conduite",
    icon: "Gauge"
  },
  {
    title: "Transposable",
    subtitle: "de véhicule en véhicule",
    icon: "RefreshCw"
  }
];

export const navigationLinks = [
  { name: "Accueil", path: "/" },
  { name: "Technologie", path: "/technologie" },
  { 
    name: "Boutique", 
    path: "/boutique",
    submenu: [
      { name: "BVA1 - Moto / Scooter / Jet-ski", path: "/boutique/moto" },
      { name: "BVA2 - Voiture de moins de 2000 cm³", path: "/boutique/voiture-2l" },
      { name: "BVA3 - Voiture > 2000 cm³ / Camping-car / 4x4 / Utilitaire", path: "/boutique/voiture-plus" },
      { name: "BVA4 - Camion / Chantier / Groupe électrogène / Maritime", path: "/boutique/utilitaires" },
      { name: "BVA5 - Chauffage mazout / Poêle / Pellet / Fioul", path: "/boutique/agricole" },
      { name: "BVA6 - Machines lourdes / Industriel", path: "/boutique/industriel" }
    ]
  },
  { name: "Commander", path: "/commander" },
  { name: "Simulateur", path: "/simulateur" },
  { name: "Installation", path: "/installation" },
  { name: "Témoignages", path: "/temoignages" },
  { name: "Notre Histoire", path: "/histoire" },
  { name: "FAQ", path: "/faq" },
  { name: "Contact", path: "/contact" },
  { name: "Devenir partenaire", path: "/devenir-partenaire" }
];

export const footerInfo = {
  copyright: "© 2026 Ecopra Suisse - Tous droits réservés",
  award: "Edison Awards 2023 Nominee - Plus de 6'000'000 de vues",
  madeIn: "Made in France - Fabriqué en France",
  links: [
    { name: "Mentions légales", path: "/mentions-legales" },
    { name: "Politique de confidentialité", path: "/confidentialite" },
    { name: "CGV", path: "/cgv" }
  ]
};

export const testimonials = [
  {
    id: 1,
    name: "Franck Gilbert",
    location: "France",
    vehicle: "Minibus années 80",
    rating: 5,
    text: "J'ai voulu tester le kit ECOPRA tout d'abord sur mon minibus des années 80. Résultat observé dès la 1ère minute en constatant une baisse d'environ 100 tours moteur. Puis test de conduite bluffant : Beaucoup plus de couple, moteur plus souple, moins bruyant, plus de puissance et gain de 20km/h en vitesse max. Christophe est un vrai pro, accueillant, à l'écoute, disponible, arrangeant, très rigolo et vraiment sympa. Je recommande vivement l'installation de cet outil révolutionnaire et très vite rentabilisé.",
    savings: "100% satisfait",
    date: "Décembre 2025",
    source: "Google Reviews"
  },
  {
    id: 2,
    name: "Benoit GAUCHER",
    location: "France",
    vehicle: "4x4 Isuzu 2.5 turbo",
    rating: 5,
    text: "Bonjour, jai fais installé sous les conseils de ma famille, ce système sur un 4x4 Isuzu 2.5 bi turbo. Le changement sur mon véhicule a été quasi immédiat. plus de couple, beaucoup plus souple à la conduite, moins de consommation et avec la même quantité de carburant plus de km soit avant 720 km plein faits à 1150 km. Je recommande vivement l'installation de ce système.",
    savings: "+430 km/plein",
    date: "Février 2023",
    source: "Google Reviews"
  },
  {
    id: 3,
    name: "Client Satisfait",
    location: "France",
    vehicle: "307 HDI 327'000 km",
    rating: 5,
    text: "Bonjour, je ne ferais pas de grand écris, ce kit est fantastique. Je confirma tout les avantages qui nous sont annoncés. Ma 307 HDI à 327000 km, opacité des fumées est de 0.35 au lieu de 1 et plus. En conso je suis passé de 6.3 l à 5.7 l. La voiture est plus agréable.",
    savings: "De 6.3L à 5.7L",
    date: "Novembre 2023",
    source: "Google Reviews"
  },
  {
    id: 4,
    name: "Franck",
    location: "France",
    vehicle: "Non spécifié",
    rating: 5,
    text: "Kit installé simplement et rapidement. Premier constat : baisse du volume sonore, moteur plus performant et économies visibles. Top !",
    savings: "Économies visibles",
    date: "Décembre 2024",
    source: "Google Reviews"
  }
];
